module.exports = __webpack_public_path__ + "img/home-whatsapp-overview.d6e24c1d.svg";